import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {SettingsAmenity} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {SettingsAmenitiesService} from '../../../services/settings-amenities.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'disabled-dates-modal',
    templateUrl: './disabled-dates-modal.component.html',
    styleUrls: ['./disabled-dates-modal.component.scss']
})
export class DisabledDatesModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledDates: Array<any> = [{id: 1, name: 'Holidays 1'}, {id: 2, name: 'Holidays 2'}, {id: 3, name: 'Holidays 3'}];
    disabledDatesArray: Array<any> = [];
    data: SettingsAmenity = new SettingsAmenity();
    disabledSubmit = false;
    disabledFileInput = false;
    attachments: Array<any> = [];
    startDate = null;
    endDate = null;
    note = '';
    minDate = new Date();
    focusedDisabledDateIndex: number;

    canadianHolidays = [
        {
            startDate: new Date(Date.UTC(2019, 0, 1, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2019, 0, 1, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2019, 3, 19, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2019, 3, 19, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2019, 4, 20, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2019, 4, 20, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2019, 6, 1, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2019, 6, 1, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2019, 7, 5, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2019, 7, 5, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2019, 8, 2, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2019, 8, 2, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2019, 9, 14, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2019, 9, 14, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2019, 10, 11, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2019, 10, 11, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2019, 11, 25, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2019, 11, 26, 0, 0, 0, 0))
        }
    ];
    canadianHolidays2020 = [
        {
            startDate: new Date(Date.UTC(2020, 0, 1, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2020, 0, 1, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2020, 1, 17, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2020, 1, 17, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2020, 3, 10, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2020, 3, 10, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2020, 3, 13, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2020, 3, 13, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2020, 4, 18, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2020, 4, 18, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2020, 6, 1, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2020, 6, 1, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2020, 7, 3, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2020, 7, 3, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2020, 8, 7, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2020, 8, 7, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2020, 9, 12, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2020, 9, 12, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2020, 10, 11, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2020, 10, 11, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2020, 11, 25, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2020, 11, 26, 0, 0, 0, 0))
        }
    ];

    canadianHolidays2021 = [
        {
            startDate: new Date(Date.UTC(2021, 0, 1, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2021, 0, 1, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2021, 3, 2, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2021, 3, 2, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2021, 3, 5, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2021, 3, 5, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2021, 4, 24, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2021, 4, 24, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2021, 6, 1, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2021, 6, 1, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2021, 7, 2, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2021, 7, 2, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2021, 8, 6, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2021, 8, 6, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2021, 9, 11, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2021, 9, 11, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2021, 10, 11, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2021, 10, 11, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2021, 11, 25, 0, 0, 0, 0)),
            endDate: new Date(Date.UTC(2021, 11, 26, 0, 0, 0, 0))
        }
    ];

    canadianHolidays2022 = [
        {
            startDate: new Date(Date.UTC(2022, 0, 1, 0, 0, 0, 0)), // January 1, Saturday	New Year’s Day
            endDate: new Date(Date.UTC(2022, 0, 1, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2022, 1, 21, 0, 0, 0, 0)), //February 21, Monday	Family Day
            endDate: new Date(Date.UTC(2022, 1, 21, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2022, 3, 15, 0, 0, 0, 0)), // April 15, Friday	Good Friday
            endDate: new Date(Date.UTC(2022, 3, 15, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2022, 4, 23, 0, 0, 0, 0)), // May 23, Monday	Victoria Day
            endDate: new Date(Date.UTC(2022, 4, 23, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2022, 6, 1, 0, 0, 0, 0)), // July 1, Friday	Canada Day
            endDate: new Date(Date.UTC(2022, 6, 1, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2022, 8, 5, 0, 0, 0, 0)), // September 5, Monday	Labour Day
            endDate: new Date(Date.UTC(2022, 8, 5, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2022, 9, 10, 0, 0, 0, 0)), //October 10, Monday	Thanksgiving
            endDate: new Date(Date.UTC(2022, 9, 10, 0, 0, 0, 0))
        },
        {
            startDate: new Date(Date.UTC(2022, 11, 25, 0, 0, 0, 0)), // December 25, Sunday	Christmas Day
            endDate: new Date(Date.UTC(2022, 11, 26, 0, 0, 0, 0)) // December 26, Monday	Boxing Day
        }
    ];

    constructor(
        public api: ApiClientService,
        public settingsAmenitiesService: SettingsAmenitiesService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {
    }

    ngOnInit() {
        this.initData();
        setTimeout(() => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        this.settingsAmenitiesService.selectedItemData.disabledDates.forEach(item => {
            this.disabledDatesArray.push(item);
        });
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsAmenitiesService.isDisabledDatesModalShow = false;
                    this.settingsAmenitiesService.serviceRequestInServiceRequestModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsAmenitiesService.isDisabledDatesModalShow = false;
            this.settingsAmenitiesService.serviceRequestInServiceRequestModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!this.startDate) toastr.warning('Start Date should not be blank.');
            if (!this.endDate) toastr.warning('End Date should not be blank.');
            return;
        }

        const data = {
            disabledDates: this.formatDisabledDates(this.disabledDatesArray),
            timeSequenceType: this.settingsAmenitiesService.selectedItemData.timeSequenceType
        };

        const updateAmenities = () => {
            const url = `/v1/amenity/${this.settingsAmenitiesService.selectedItemData.id}.json`;
            this.settingsAmenitiesService.api.patch('domainAmenities', url, data).subscribe(
                () => this.updateView('The Disabled Dates were successfully updated'),
                (error) => this.api.errorHandler(error, 'Update failed!')
            );
        };

        if (this.startDate && this.endDate) {
            swal(ConstantsService.getSwalConfig('Are you sure?', 'You have entered the dates, but did not add them to the list.'),
                updateAmenities
            );
        } else {
            updateAmenities();
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.settingsAmenitiesService.getData();
        this.form.reset();
        this.hideModal();
    }

    addDisabledDates(): void {
        if (this.startDate && this.endDate && this.note.length < 256) {
            if (this.startDate.getTime() == this.endDate.getTime())
                this.endDate = new Date(this.endDate.getTime() + 24 * 60 * 60000 - 1);
            this.disabledDatesArray.push({
                startDate: new Date(new Date(this.startDate).getTime() - new Date(this.startDate).getTimezoneOffset() * 60000),
                endDate: new Date(new Date(this.endDate).getTime() - new Date(this.endDate).getTimezoneOffset() * 60000),
                note: this.note
            });
            this.startDate = null;
            this.endDate = null;
            this.note = '';
        }
    }

    deleteDisabledDates(dates): void {
        const index = this.disabledDatesArray.indexOf(dates);
        if (index != -1)
            this.disabledDatesArray.splice(index, 1);
    }

    myFilter = (d: Date): boolean => {
        let flag = true;
        this.disabledDatesArray.forEach((date) => {
            const calendarDay = new Date(d);
            const startDate = new Date(new Date(date.startDate).getTime() + new Date(date.startDate).getTimezoneOffset() * 60000);
            const endDate = new Date(new Date(date.endDate).getTime() + new Date(date.startDate).getTimezoneOffset() * 60000);
            if (calendarDay >= startDate && calendarDay <= endDate)
                flag = false;
        });
        return flag;
    };

    onStartDateChange(): void {
        if (new Date(this.startDate) > new Date(this.endDate)) {
            this.endDate = null;
            this.form.value.endDate = null;
        }
    }

    formatDisabledDates(unformattedDates) {
        return unformattedDates.map(date => ({
            startDate: date.startDate,
            endDate: date.endDate,
            ...(date.note ? {note: date.note} : {})
        }));
    }

    addPresetDiabledDates() {
        this[this.form.controls['preSetDisabledDates'].value].forEach(date => {
            const alreadyExists = this.disabledDatesArray.some(d => d.startDate == date.startDate && d.endDate == date.endDate);
            if (!alreadyExists)
                this.disabledDatesArray.push(date);
        });
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/disabled-dates-modal/disabled-dates-modal.component.ts